import React from 'react';
import {Grid} from '@material-ui/core';
import {Controller, useFormContext} from 'react-hook-form';
import {
    FormControl,
    FormLabel,
    RadioGroup as MRadioGroup,
    Radio,
    FormControlLabel,
    FormHelperText,
} from '@material-ui/core';
import get from 'lodash.get';
import {optionsObjectToArray} from './optionsHelper';
import './layout-helper.scss';
import {toSnakeCase} from 'components/forms/locale/utils';
import Text from './Text';

function RadioGroup(props) {
    const {name, label, row, options, onChange, required, hidden, ...rest} =
        props;
    const {control, errors} = useFormContext();
    const error = get(errors, name);

    return hidden ? (
        <Text {...{name, label, hidden, ...rest}} />
    ) : (
        <FormControl fullWidth component='fieldset' error={!!error}>
            <FormLabel required={required} component='legend'>
                {label}
            </FormLabel>
            <Controller
                as={
                    <MRadioGroup aria-label={label} row={row}>
                        <Grid container direction={row ? 'row' : 'column'}>
                            {optionsObjectToArray(options).map(option => (
                                <Grid
                                    item
                                    className='form-field__inline-radio'
                                    key={option.value}
                                >
                                    <FormControlLabel
                                        labelPlacement='end'
                                        value={option.value}
                                        control={
                                            <Radio
                                                data-cy={`form-field-${toSnakeCase(
                                                    name
                                                )}-${toSnakeCase(
                                                    option.value
                                                )}`}
                                            />
                                        }
                                        label={option.label}
                                        onChange={onChange}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </MRadioGroup>
                }
                name={name}
                control={control}
            />
            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    );
}
const NoControllerRadioGroup = ({
    required,
    error,
    label,
    row,
    options,
    onChange,
    name,
}) => {
    return (
        <FormControl fullWidth component='fieldset' error={!!error}>
            <FormLabel required={required} component='legend'>
                {label}
            </FormLabel>
            <MRadioGroup aria-label={label} row={row}>
                <Grid container direction={row ? 'row' : 'column'}>
                    {optionsObjectToArray(options).map(option => (
                        <Grid
                            item
                            className='form-field__inline-radio'
                            key={option.value}
                        >
                            <FormControlLabel
                                labelPlacement='end'
                                value={option.value}
                                control={
                                    <Radio
                                        data-cy={`form-field-${toSnakeCase(
                                            name
                                        )}-${toSnakeCase(option.value)}`}
                                    />
                                }
                                label={option.label}
                                onChange={onChange}
                            />
                        </Grid>
                    ))}
                </Grid>
            </MRadioGroup>

            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    );
};

export default RadioGroup;
export {NoControllerRadioGroup};
